'use client';
import { VStack } from '@chakra-ui/react';
import { useCallback, useEffect, useRef } from 'react';

import { useHeaderBoundStore } from 'app/selectors';
import Header from 'widgets/Header';
import Footer from 'widgets/Footer';
import Cookies from 'features/Cookies';
// import useRadio from 'features/useRadio';
import AnimatedCircles from 'shared/AnimatedCircles';
import { useCustomLocations } from 'shared/hooks';
import { throttle } from 'shared/lib';

const overlapOffset = 50;

const PageLayout = ({ children }) => {
  const {
    isPersonCardPage,
    isCulturalCodePages,
    isCertificatesPages,
    isProjectsCasesPages,
    isRecommendationLettersPages,
  } = useCustomLocations();
  const { setIsLight, setIsOverlapsFooter } = useHeaderBoundStore();
  const headerRef = useRef(null);
  const footerRef = useRef(null);
  // useRadio();

  const checkHeaderAndFooterOverlapped = useCallback(() => {
    if (headerRef.current && footerRef.current) {
      const a = headerRef.current.getBoundingClientRect();
      const b = footerRef.current.getBoundingClientRect();

      if (a.bottom >= b.top) {
        setIsOverlapsFooter(true);
      } else {
        setIsOverlapsFooter(false);
      }

      if (a.top + overlapOffset <= b.top + b.height && a.top + a.height > b.top + overlapOffset) {
        setIsLight(true);
      } else {
        setIsLight(false);
      }
    }
  }, [setIsLight, setIsOverlapsFooter]);

  useEffect(() => {
    const throttledCheckFn = throttle(checkHeaderAndFooterOverlapped);
    window.addEventListener('scroll', throttledCheckFn);
    throttledCheckFn();

    return () => window.removeEventListener('scroll', throttledCheckFn);
  }, [checkHeaderAndFooterOverlapped]);

  return (
    <VStack
      w="full"
      minH="100vh"
      boxSizing="border-box"
      pos="relative"
      zIndex="1"
      gap="0"
      overflow="clip"
      bgColor={isPersonCardPage && 'bg.gray'}
    >
      {!isCertificatesPages && !isRecommendationLettersPages && <Header ref={headerRef} />}

      <VStack w="full" as="main" gap="0">
        {!isCulturalCodePages &&
          !isPersonCardPage &&
          !isCertificatesPages &&
          !isRecommendationLettersPages &&
          !isProjectsCasesPages && <AnimatedCircles />}

        {children}
      </VStack>

      {!isCertificatesPages && !isRecommendationLettersPages && <Footer ref={footerRef} />}

      <Cookies />
    </VStack>
  );
};

export default PageLayout;
